<template>
  <div class="sp-template">
    <div class="h-title">财务对账</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="conditions" class="header-search__form" size="small" label-width="100px">
          <el-row>
            <el-form-item label="付款状态">
              <el-select v-model.lazy="conditions.status" filterable clearable>
                <el-option v-for="(d, i) in paymentStatus" :key="i" :label="d.label" :value="d.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户">
              <el-select v-model.lazy="conditions.orgOwner" filterable clearable multiple>
                <el-option v-for="(d, i) in customerList" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="供应商">
              <el-select v-model="conditions.supplier" filterable clearable>
                <el-option v-for="item in suppliers" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="通配搜索">
              <el-input :autosize="{ minRows: 3, maxRows: 6}" v-model="wildcardTextsTextArea" type="textarea" placeholder="目前支持订单号、客户订单号、转单号、批次号同时匹配，多个用回车分割"></el-input>
            </el-form-item>
          </el-row>
          <el-collapse-transition>
						<div v-show="isSearchMore">
              <el-row>
                <el-form-item label="业务员">
                  <el-select v-model.lazy="conditions.salesMan" filterable clearable multiple>
                    <el-option v-for="(d, i) in salesmans" :key="i" :label="d.name" :value="d.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="渠道">
                  <el-select v-model.lazy="conditions.channel" filterable clearable multiple>
                    <el-option v-for="(d, i) in channelList" :key="i" :label="d.name" :value="d.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="类型">
                  <el-select v-model="conditions.timeType" clearable>
                    <el-option v-for="(d, i) in timeTypes" :key="i" :label="d.name" :value="d.id"></el-option>
                  </el-select>
                </el-form-item>
              <!-- </el-row>
              <el-row> -->
                <el-form-item label="开始日期">
                  <el-date-picker v-model="conditions.startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期">
                  <el-date-picker v-model="conditions.endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
                </el-form-item>
                
              <!-- </el-row>

              <el-row> -->
                <el-form-item label="订单开始日期">
                  <el-date-picker v-model="conditions.orderStartDate" type="date" value-format="yyyy-MM-dd" placeholder="订单开始日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="订单结束日期">
                  <el-date-picker v-model="conditions.orderEndDate" type="date" value-format="yyyy-MM-dd" placeholder="订单结束日期"></el-date-picker>
                </el-form-item>

                <el-form-item label="分公司" >   
                  <el-select v-model="conditions.companyId" clearable>
                    <el-option v-for="(d, i) in companys" :key="i" :label="d.name" :value="d.id"></el-option>
                </el-select>        
              </el-form-item>

              <!-- </el-row>
              <el-row> -->
                <el-form-item label="供应商账单号">
                  <el-input v-model="conditions.supplierInvoiceId" clearable type="text" placeholder="供应商账单号"></el-input>
                </el-form-item>
                <el-form-item label="冻结状态">
                  <el-select v-model.lazy="conditions.freezeStatus" filterable clearable>
                    <el-option key="1" label="未冻结收入" value="1"></el-option>
                    <el-option key="2" label="已冻结收入" value="2"></el-option>
                    <el-option key="3" label="未冻结成本" value="3"></el-option>
                    <el-option key="4" label="已冻结成本" value="4"></el-option>
                  </el-select>
                </el-form-item>                

              </el-row>

            </div>
          </el-collapse-transition>
          <div class="search-form__buttons">
            <el-button v-if="in_configs(90101)" type="primary" size="small" @click="searchTask()">搜 索</el-button>
            <el-button v-if="in_configs(90101)" size="small" @click="reset()">清 空</el-button>
            <a class="toggle-icon" @click.stop.prevent="isSearchMore = !isSearchMore">
							<b v-show="isSearchMore">隐藏</b><b v-show="!isSearchMore">展开</b>更多搜索条件
            </a>
          </div>
        </el-form>
      </div>
      <div class="table-button__groups">
        <div class="button-groups">
          <el-button  size="small" v-if="in_configs(90104)" @click="freezeOrder">冻结</el-button>
          <el-button  size="small" v-if="in_configs(90105)" @click="unlockOrder">解锁</el-button>
          <el-button v-if="in_configs(90102)" size="small" @click="exportExcel()">导出账单</el-button>
          <el-button v-if="in_configs(90103)" size="small" @click="supplierPayPop()">供应商付款</el-button>
          <el-button v-if="in_configs(90106)" size="small" @click="createInvoicePop()">生成供应商账单</el-button>
        </div>
      </div>
      <el-table ref="multipleTable" :data="tableData" stripe border show-summary style="width: 100%" max-height="800" :summary-method="getSummaries" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="customerName" label="客户"></el-table-column>
        <el-table-column label="分公司">
          <template slot-scope="scope">
            {{companyMap[scope.row.companyId]}}
          </template>
        </el-table-column>
        <el-table-column prop="orderId" label="订单号"></el-table-column>
        <el-table-column prop="channelName" label="渠道"></el-table-column>
        <el-table-column prop="countryName" label="国家"></el-table-column>
        <el-table-column prop="weight" label="实重"></el-table-column>
        <el-table-column prop="volumeWeight" label="体积重"></el-table-column>
        <el-table-column prop="chargeWeight" label="计费重"></el-table-column>
        <el-table-column prop="amount" label="金额"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column prop="trace" label="计费公式"></el-table-column>
        <el-table-column prop="cost" label="成本"></el-table-column>
        <el-table-column label="供应商">
          <template slot-scope="scope" >
						{{supplierMap[scope.row.supplier] == null ? scope.row.supplier : supplierMap[scope.row.supplier]}}
					</template>
        </el-table-column>
        <el-table-column prop="supplierInvoiceId" label="供应商账单号"></el-table-column>
        <el-table-column prop="statusName" label="付款状态"></el-table-column>
        <el-table-column prop="salesAmountLocked" label="应收冻结">
          <template slot-scope="scope" >
						{{scope.row.salesAmountLocked ? '已冻结' : '未冻结' }}
					</template>
        </el-table-column>
        <el-table-column prop="costAmountLocked" label="应付冻结">
          <template slot-scope="scope" >
						{{scope.row.costAmountLocked ? '已冻结' : '未冻结' }}
					</template>
        </el-table-column>
        <el-table-column prop="profit" label="利润"></el-table-column>
        <el-table-column prop="salesManName" label="业务员"></el-table-column>
        <el-table-column label="日期" fixed="right">
          <template slot-scope="scope">
            {{formatDate(new Date(scope.row.date), 'yyyy-MM-dd HH:mm:ss')}}
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="conditions.currentPage" :page-sizes="[10, 20, 50, 100,1000]" :page-size="conditions.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>

    <form action="" method="post" target="_blank" id="myform">
    </form>

    <!-- 提示弹框2 -->
    <el-dialog title="供应商付款" class="common-select__dialog" :visible.sync="dialogCheckVisible" width="30%">

      <el-form size="small" label-width="100px">
          <el-form-item label="供应商">
						<el-select v-model="sumbitForm.supplier" filterable clearable>
              <el-option v-for="item in suppliers" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
					</el-form-item>

        <el-form-item label="付款状态">
          <el-select v-model.lazy="sumbitForm.status" filterable clearable>
            <el-option v-for="(d, i) in paymentStatus2" :key="i" :label="d.label" :value="d.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogCheckVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="supplierPay()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 生成供应商账单 -->
    <el-dialog title="生成供应商账单" class="common-select__dialog" :visible.sync="dialogVisibleInvoice" width="30%">

      <el-form size="small" label-width="100px">
        <el-form-item label="供应商">
          {{supplierMap[conditions.supplier]}}
        </el-form-item>
          <el-form-item label="总成本">
						{{createInvoiceAllCost}}
					</el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisibleInvoice = false">取 消</el-button>
        <el-button size="small" type="primary" @click="createInvoice()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 冻结弹窗--> 
    <el-dialog :title="changeTitle" class="common-select__dialog" :visible.sync="orderFreezedialog" width="30%">
        <el-form size="small" label-width="100px" style="margin-left:-85px">
          <el-form-item label="">
            <div class="chgstyle">
          <el-checkbox-group v-model="freezeObj.locks" @change="chouseType">
            <el-checkbox label="sales_amount_locked"  class="shouru">收入</el-checkbox>
            <el-checkbox label="cost_amount_locked"  class="shouru">成本</el-checkbox>
          </el-checkbox-group>
            </div>
					</el-form-item>
        <el-form-item label="订单号" label-width="150px">
          <el-input type="textarea" v-model="orderIds" placeholder="多个订单号用回车分割" style="width:200px" @change="changeOrder"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="orderFreezedialog = false">取 消</el-button>
        <el-button size="small" type="primary" @click="sureFreeze()" >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { base64ToUint8Array, dateFormat } from '@/util/formUtil'
// import {getFreezeOrder,getUnlock,textPost} from '@/util/reconciliation'

export default {
  data() {
    return {
      
      createInvoiceAllCost: 0,
      dialogVisibleInvoice: false,
      changeTitle:'',
      checkList:[],
      orderFreezedialog:false, //冻结弹窗显示变量
      freezeObj:{
        locks:[],
        orderIds:[]
      }, //冻结传给后台的参数
      orderIds:'',
      freezeInput:'', 
      suppliers: [],
      supplierMap: {},
      conditions: {
        orgOwner: [],
        salesMan: [],
        channel: [],
        supplier: "",
        status: "",
        startDate: "",
        endDate: "",
        orderStartDate : "",
        orderEndDate : "",
        pageSize: 10,
        currentPage: 1,
        export: 0,
        wildcardTexts: "",
        wildcardTextsJson: "",
        timeType: "charge",
        companyId: "",
        freezeStatus: ""
      },
      isSearchMore: false,
      sumbitForm: {
        ids: [],
        supplier: "",
        status: "",
        orderIds: [],
        paymentStatus:[]
      },
      //orderIds: '',
      wildcardTextsTextArea: "",
      paymentStatus: [
        // { label: "所有", value: "" },
        // { label: "未付款", value: "NOT_PAID" },
        // { label: "已付款", value: "ACCOUNT_PAID" },
        // { label: "已审核", value: "AUDITED" },

        { label: "未审核", value: "NOT_AUDITED" },
        { label: "已审核", value: "AUDITED" },
        { label: "已复核", value: "RECHECKED" },
        { label: "已生成账单", value: "CREATED_INVOICE" },
        { label: "已付款", value: "ACCOUNT_PAID" }
      ],
      paymentStatus2: [
        { label: "已审核", value: "AUDITED" },
        { label: "已复核", value: "RECHECKED" }
      ],
      total: 0,
      cost: 0,
      salesAmount: 0,
      multipleSelection: [],
      customerList: [],
      customerMaps: {},
      channelList: [],
      channelsMaps: {},
      tableData: [],
      salesmans: [],
      dialogCheckVisible: false,
      timeTypes: [
        { id: "charge", name: "扣费时间" },
        { id: "deliver", name: "发货时间" }
      ],
      companys: [],
      companyMap: {}
    };
  },
  created() {
    setTimeout(() => {
      this._initData();      

    }, 1000);
    // console.log('/order/amount/lock')
  },
  methods: {
    //查询渠道
    findAllChannle() {
      return this.$request1.get(
        '/system/channel/all'
      );
    },
    //查询客户
    findAllCustomerName() {
      return this.$request1.get(
        '/customerAll'
      );
    },
    // 初始化查询数据
    _initData() {
      let _this = this;
      let urlArr = [this.findAllCustomerName(), this.findAllChannle()];
      this.$axios.all(urlArr).then(
        this.$axios.spread(function(customerData, channelData) {
          _this.initCustomerData(customerData);
          _this.initChannelData(channelData);
          _this.loadRoleList("业务员");

          // _this.query();
          _this.querySupplier();

          _this.queryCompany();

        })
      );
    },
    // 对查询的渠道做处理
    initChannelData(data) {
      console.log(this.channelList);
      this.channelList = data.data;
      if (this.channelList.length > 0) {
        this.channelList.forEach(c => {
          this.channelsMaps[c.id] = c.name;
        });
      }
    },
    // 对查询的客户做处理
    initCustomerData(data) {
      if (data.data.success) {
        this.customerList = data.data.data;
        if (this.customerList.length > 0) {
          this.customerList.forEach(c => {
            this.customerMaps[c.id] = c.name;
          });
        }
      }
    },
    queryCompany(){
        let _this = this;
        this.$request1({
            method: 'get',
            url: '/system/company',
            params: {
              page:  1,
              pageSize: -1
            }
        })
        .then(response => {          
            _this.companys = response.data.data;
            _this.companys.forEach(a => {
                _this.companyMap[a.id] = a.name;
            });
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 表格多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    // 表尾行合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      for (let i = 0; i < 19; i++) {
        sums.push("")
      }
      sums[1] = "本期合计";
      sums[2] = this.total + "票";
      sums[9] = this.salesAmount + "元";
      sums[12] = this.cost + "元";
      sums[16] = new Number(this.salesAmount - this.cost).toFixed(2) + "元";

      return sums;
    },
    //分页
    handleSizeChange(val) {
      this.conditions.currentPage = 1;
      this.conditions.pageSize = val;
      this.query();
    },
    handleCurrentChange(val) {
      this.conditions.currentPage = val;
      this.query();
    },
    reset() {
      this.conditions = {
        orgOwner: [],
        salesMan: [],
        channel: [],
        supplier: "",
        status: "",
        startDate: "",
        endDate: "",
        pageSize: 10,
        currentPage: 1,
        export: 0,
        wildcardTexts: "",
        wildcardTextsJson: "",
        timeType: "charge"
      };
      this.searchTask();
    },
    //搜索
    searchTask() {
      this.conditions.currentPage = 1;
      this.query();
      //console.log("搜索");
    },
    query() {
      let _this = this;
      _this.conditions.export = 0;

      _this.conditions.wildcardTexts = "";
      if (this.wildcardTextsTextArea) {
        this.conditions.wildcardTexts = this.wildcardTextsTextArea.split(/\n+/gim).map(a => a.trim()).filter(a => a).join(',')
      }

      if(this.conditions.supplierInvoiceId){
        if(!/^[0-9]+$/.test(this.conditions.supplierInvoiceId)){
          this.$message.error('供应商账号号只能为数字')
          return false
        }
      }

      this.$request1
        .post(
          '/account/reconciliation',
          _this.conditions,
          {
            timeout: 10000,
            withCredentials: true
          }
        )
        .then(res => {
          if(res.data.success){
            _this.tableData = res.data.data.list;
            _this.total = res.data.total;

            _this.cost = res.data.data.cost;
            _this.salesAmount = res.data.data.salesAmount;
          }else{
            _this.$message.error(res.data.message)
            
            _this.tableData = []
            _this.total = 0
            _this.cost = 0
            _this.salesAmount = 0
          }
          
        })
        .catch(function(error) {
          //console.log(error);
        });
    },
    exportExcel() {
      let _this = this;
      _this.conditions.export = 1;

      _this.conditions.wildcardTexts = ''

      if (this.wildcardTextsTextArea) {
        this.conditions.wildcardTexts = this.wildcardTextsTextArea.split(/\n+/gim).map(a => a.trim()).filter(a => a).join(',')
      }


      this.$request1({
          url: '/account/reconciliation',
          method: 'post',
          data: this.conditions,
          responseType: 'blob'
        }).then(res => {
          _this.conditions.export = 0
          const link = document.createElement('a')
          // let array = base64ToUint8Array(res.data)
          // let blob = new Blob([array])
          let blob = new Blob([res.data])
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
          link.setAttribute('download', `reconciliation_${timestr}.xlsx`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
      
      // var url = tmsSpringUrl + '/account/reconciliation';
      // var form = document.getElementById("myform");
      // form.setAttribute("action", url);
      // var fhtml = "";
      // for (var key in _this.conditions) {
      //   if (
      //     key != "orgOwner" &&
      //     key != "salesMan" &&
      //     key != "channel"
      //   ) {
      //     fhtml += '<input type="hidden" name="' + key + '" value="' + (_this.conditions[key] == null ? "" : _this.conditions[key]) + '" />';
      //   }
      // }
      // if (this.conditions.salesMan.length > 0) {
      //   this.conditions.salesMan.forEach(a => {
      //     fhtml += '<input type="hidden" name="salesMan[]" value="' + a + '" />';
      //   });
      // }
      // if (this.conditions.orgOwner.length > 0) {
      //   this.conditions.orgOwner.forEach(a => {
      //     fhtml += '<input type="hidden" name="orgOwner[]" value="' + a + '" />';
      //   });
      // }
      // if (this.conditions.channel.length > 0) {
      //   this.conditions.channel.forEach(a => {
      //     fhtml += '<input type="hidden" name="channel[]" value="' + a + '" />';
      //   });
      // }

      // fhtml +=
      //   '<input type="hidden" name="token" value="' +
      //   this.$getToken() +
      //   '" />';
        
      // form.innerHTML = fhtml;
      
      // form.submit();
    },
    supplierPayPop() {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$message.error("请选择账单");
        return false;
      }
      //console.log(this.multipleSelection);
      let ids = [];
      let orderIds = [];
      let savelist=[]

      // 别的状态提示
      let elseStatus = false

      for (let i = 0; i < this.multipleSelection.length; i++) {
        ids.push(this.multipleSelection[i].id);
        orderIds.push(this.multipleSelection[i].orderId);
        if(this.multipleSelection[i].status=='CREATED_INVOICE' || this.multipleSelection[i].status=='ACCOUNT_PAID'){
          elseStatus = true
        }
      }
      if(elseStatus){
        _this.$message.error("已生成账单和已付款的费用不能选择。");
        return;
      }
      

      this.dialogCheckVisible = true;
      _this.sumbitForm.ids = ids;
      _this.sumbitForm.orderIds = orderIds;
      _this.sumbitForm.supplier = "";
      _this.sumbitForm.status = "AUDITED";
      
    },
    // 生成供应商账单
    createInvoicePop(){
      let _this =  this
      if(this.conditions.status!='RECHECKED'){
        this.$message.error('请在搜索条件选择已复核状态')
        return;
      }
      if(!this.conditions.supplier){
        this.$message.error('请在搜索条件选择供应商')
        return;
      }

      _this.conditions.wildcardTexts = "";
      if (this.wildcardTextsTextArea) {
        this.conditions.wildcardTexts = this.wildcardTextsTextArea.split(/\n+/gim).map(a => a.trim()).filter(a => a).join(',')
      }

      this.$request1
        .post(
          '/report/account/query-cost',
          _this.conditions,
          {
            withCredentials: true
          }
        ).then(function(res) {

          _this.dialogVisibleInvoice = true;
          if(res.data.success){
            _this.createInvoiceAllCost = res.data.data.cost;
          }
          
        }).catch(function(error) {console.log(error);});
      
    },
    createInvoice(){
      let _this = this

      this.$confirm("是否确定生成供应商账单？", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
          // this.$confirm("是否再次确定生成供应商账单？", "再次警告", {
          //   confirmButtonText: "确定",
          //   cancelButtonText: "取消",
          //   type: "info"
          // }).then(() => {
          //     let _this = this;
              
          // }) 

          _this.conditions.wildcardTexts = "";
          if (this.wildcardTextsTextArea) {
            this.conditions.wildcardTexts = this.wildcardTextsTextArea.split(/\n+/gim).map(a => a.trim()).filter(a => a).join(',')
          }

          this.$request1.post(
              '/supplier-invoice/create-supplier-invoice',
              _this.conditions,
              {
                withCredentials: true
              }
            ).then(function(res) {

              
              if(res.data.success){
                _this.$message.success("生成供应商账单成功")
                _this.dialogVisibleInvoice = false;
                _this.searchTask()
              }else {
                _this.$message.error(res.data.message)
              }
              
            }).catch(function(error) {console.log(error);});

      })
    },
    supplierPay() {
      let _this = this;

      if (
        !_this.sumbitForm.supplier ||
        _this.sumbitForm.supplier.trim() == ""
      ) {
        _this.$notify.error({
          title: "错误",
          message: "供应商不能为空"
        });
        return;
      }
      _this.$request1
        .post(
          '/account/reconciliation/update',
          _this.sumbitForm,
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          //console.log(res);
          if (res.data.success) {
            _this.$message.success("Success");
            _this.query();
            _this.dialogCheckVisible = false;
          } else {
            _this.$alert(res.data.message);
          }
        })
        .catch(function(error) {
          //console.log(error);
          _this.$notify.error({
            title: "错误",
            message: error.response.data
          });
        });
    },
    //查询业务员和客服
    loadRoleList(role) {
      let _this = this;
      _this.$request1
        .get(
          '/staffrole',
          {
            params: {
              role: role
            }
          },
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.data.success) {
            if (role == "业务员") {
              _this.salesmans = res.data.data;
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 供应商名称
    querySupplier() {
      this.$request1({
        method: 'GET',
        url: '/supplier'
      })
        .then(response => {
          this.suppliers = response.data;
          if (this.suppliers != null && this.suppliers.length > 0) {
            this.suppliers.forEach(item => {
              this.supplierMap[item.id] = item.name;
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    formatDate(date, fmt) {
      if (!date) {
        return "";
      }
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, //小时
        "H+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds() //毫秒
      };
      var week = {
        "0": "/u65e5",
        "1": "/u4e00",
        "2": "/u4e8c",
        "3": "/u4e09",
        "4": "/u56db",
        "5": "/u4e94",
        "6": "/u516d"
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      if (/(E+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (RegExp.$1.length > 1
            ? RegExp.$1.length > 2
              ? "/u661f/u671f"
              : "/u5468"
            : "") + week[date.getDay() + ""]
        );
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    },
    // 供应商名称
    querySupplier() {
      this.$request1({
        method: 'GET',
        url: '/supplier'
      })
        .then(response => {
          this.suppliers = response.data;
          if (this.suppliers != null && this.suppliers.length > 0) {
            this.suppliers.forEach(item => {
              this.supplierMap[item.id] = item.name;
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //冻结按钮操作
    freezeOrder () {
      this.changeTitle='冻结订单'
      this.orderFreezedialog=!this.orderFreezedialog
    },
    //解锁按钮 操作 
    unlockOrder () {
      this.changeTitle='解锁订单';
      this.orderFreezedialog=!this.orderFreezedialog
    },
    // 解锁弹窗 确定按钮 请求 
   async sureFreeze () {
     this.orderIds.split(/\n+/gim).forEach((d, i) => {
        if (d && d != "") {
          this.freezeObj.orderIds.push(d);
        }
      });
      if (this.freezeObj.locks.length==0) {
        // this.$message.warning('请选择需要操作的订单')
        this.$toast.error('请选择需要操作的订单')
      }  else {
           if (this.changeTitle=='冻结订单') {
        this.$request1
        .post(
          '/order/amount/lock',
          this.freezeObj,
          {
            timeout: 10000,
            withCredentials: true
          }
        ).then((res)=>{
           if(res.data.success) {
            // this.$message.success('冻结成功')
            this.$toast.success('冻结成功')
            this.orderFreezedialog=!this.orderFreezedialog;
            this.orderIds=''
            this.freezeObj.locks=[]
            this.freezeObj.orderIds=[]
            this.query();
          } else {
            // this.$message.warning('操作失败');
            this.$toast.warning('操作失败')
            this.orderIds='';
            this.freezeObj.locks=[]
            this.freezeObj.orderIds=[]
          }
        }) .catch(error => {
          console.log(error);
        });
      } else {
          this.$request1
        .post(
          '/order/amount/unlock',
          this.freezeObj,
          {
            timeout: 10000,
            withCredentials: true
          }
        ).then((res)=>{
           if(res.data.success) {
            // this.$message.success('解锁成功')
            this.$toast.success('解锁成功')
            this.orderFreezedialog=!this.orderFreezedialog;
            this.orderIds=''
            this.freezeObj.locks=[]
            this.freezeObj.orderIds=[]
            this.query();
          } else {
            this.$toast.warning('操作失败');
            this.orderIds='';
            this.freezeObj.locks=[]
            this.freezeObj.orderIds=[]
          }
        })
         .catch(error => {
          console.log(error);
        });
       }
      }  
    },
    //checkbox  操作 
    chouseType(val) {
      this.freezeObj.locks=val;
    },
    //input 改变  
    changeOrder () {
      // this.orderIds.split(/\n+/gim).forEach((d, i) => {
      //   if (d && d != "") {
      //     this.freezeObj.orderIds.push(d); 
      //   }
      // });
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .shouru .el-checkbox__inner {
  border-radius: 50% !important;
}
</style>
<style scoped>
  .chgstyle >>> .el-checkbox__inner {
      border-radius: 50% !important;
  }
</style>





// WEBPACK FOOTER //
// src/views/account/reconciliation.vue